import ComingSoonScreen from "views/00_Airdrop/airdrop_screen"

const NotFoundPage = () => <ComingSoonScreen />

NotFoundPage.chains = []

export default NotFoundPage
